<template>
  <div class="lesson-test-navigation">
    <Button class="-xs-" :is-loading="isLoading" @click="$emit('saveBlock')">Сохранить</Button>
    <div class="lesson-test-navigation-stepper-container">
      <Stepper :current-step-idx="currentSlideIdx" :steps="slides" @goToStep="goToSlide"></Stepper>
    </div>
  </div>
</template>

<script>
import Stepper from '@/components/UiKit/v2/Stepper';

export default {
  components: {
    Stepper
  },
  props: ['slides', 'currentSlideIdx', 'isLoading'],
  methods: {
    goToSlide(idx) {
      if (idx !== this.currentSlideIdx) {
        this.$emit('goToSlide', idx);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-test-navigation-stepper-container {
  margin-top: 12px;
}
</style>
